import { render, staticRenderFns } from "./IconSettingsPayment.vue?vue&type=template&id=38f94d0d&"
import script from "./IconSettingsPayment.vue?vue&type=script&lang=js&"
export * from "./IconSettingsPayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38f94d0d')) {
      api.createRecord('38f94d0d', component.options)
    } else {
      api.reload('38f94d0d', component.options)
    }
    module.hot.accept("./IconSettingsPayment.vue?vue&type=template&id=38f94d0d&", function () {
      api.rerender('38f94d0d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconSettingsPayment.vue"
export default component.exports